export default __webpack_public_path__ + "ff79eeb9772eb79a4aceeefaaef03340.png";